import React, { useEffect, useState, useRef } from 'react';
import { get, isEmpty } from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
// Redux
import { useDispatch, useSelector } from 'react-redux';
import {
  noticeBoardList,
  noticeBoardDetail,
} from '../../../actions/noticeboardActions';
import { dateFormat } from '../../../api/dateFormat';
// components
import NoData from '../../../components/NoData';
import PageHeading from '../../../components/PageHeading';
import PopUpModal from '../../../components/PopUpModal';
import { Skeleton } from '@material-ui/lab';
// styles
import './styles.scss';

const useStyles = makeStyles((theme) => ({
  dialogCustomizedWidth: {
    [theme.breakpoints.up('xs')]: {
      'max-width': '100%',
    },
    [theme.breakpoints.up('sm')]: {
      'max-width': '80%',
    },
    [theme.breakpoints.up('md')]: {
      'max-width': '50%',
    },
    [theme.breakpoints.up('xl')]: {
      'max-width': '35%',
    },
  },
  dialogPosition: {
    position: 'absolute',
    right: '0px',
    top: '0px',
  },
}));

export default function NoticeBoard() {
  const childRef = useRef();
  const classes = useStyles();
  // State
  const [isFetching, setIsFetching] = useState(false);
  const [popupHeader, setPopupHeader] = useState(<div>Notice</div>);
  const [popupBody, setPopupBody] = useState('');
  //   Reducers
  const dispatch = useDispatch();
  const jwt = useSelector((state) => get(state, 'loginReducer.data.jwt', {}));
  const noticeList = useSelector((state) =>
    get(state, 'noticeboardReducer.data', {})
  );
  const errorMessage = useSelector((state) =>
    get(state, 'noticeboardReducer.errorMessage', '')
  );

  useEffect(() => {
    setIsFetching(true);
    noticeBoardList(jwt, dispatch).then(() => {
    setIsFetching(false);
    });
  }, []);

  const handleMonth = (date) => {
    let dateString = dateFormat(date);
    return dateString.substr(3, 3);
  };
  const handleDay = (date) => {
    let dateString = dateFormat(date);
    return dateString.substr(0, 2);
  };

  const populateNoticeList = () => {
    const list = [];
    const whenLoading = [1,1,1,1];
    isFetching ? 
    whenLoading.map((item, index) => {
      list.push(
        <div className="notice-list" index={`${item}-${index}`}>
          <Skeleton className="notice-date" />
          <Skeleton className="flex-column flex-justify-center ml-20" width="20%"/>
        </div>
      );
    })
    :
    noticeList.map((data) => {
      return list.push(
        <div
          className="notice-list"
          onClick={() => {
            noticeBoardDetail(jwt, data.UniqueCode, dispatch).then(
              (noticeDetail) => {
                setPopupHeader(
                  get(noticeDetail, 'data.NoticeTitle', <div>Notice</div>)
                );
                setPopupBody(
                  <div className="iframe-responsive">
                    {/* <iframe
                      width="100%"
                      frameBorder="0"
                      src={get(
                        noticeDetail,
                        'data.NoticeDescription',
                        ''
                      ).replace('http:', 'https:')}
                      className="embed-iframe"
                    /> */}
                    {get(noticeDetail, 'data.PictureURL', '') ? (
                      <img src={get(noticeDetail, 'data.PictureURL', '')} />
                    ) : <div
                    dangerouslySetInnerHTML={{
                      __html: get(noticeDetail, 'data.NoticeDescription', ''),
                    }}
                    className="height-100"
                  />}
                  </div>
                );
                childRef.current.handleClickOpen();
              }
            );
          }}
        >
          <div className="notice-date">
            <span className="day">{handleMonth(data.NoticeDate)}</span>
            <span className="date">{handleDay(data.NoticeDate)}</span>
          </div>
          <div className="flex-column flex-justify-center ml-20">
            <div className="title">{data.NoticeTitle}</div>
          </div>
        </div>
      );
    });
    return list;
  };

  return (
    <>
      <PageHeading titlePrimary="Notice" titleSecondary="Board" />
      {isFetching || (noticeList != null && noticeList.length > 0) ? (
        <>{populateNoticeList()}</>
      ) : (
        <NoData
          message={!isEmpty(errorMessage) ? errorMessage : 'No data Available'}
        />
      )}
      <PopUpModal
        ref={childRef}
        data={[]}
        header={popupHeader}
        body={popupBody}
        width={classes.dialogCustomizedWidth}
        position={classes.dialogPosition}
        fullScreen={true}
        className="full-content-popup"
      />
    </>
  );
}
